import React from 'react';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props extends ButtonProps {
  disabled?: boolean;
  label?: string;
  loading?: boolean;
  spinnerClassName?: string;
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: () => void;
}

const LoadingButton = ({
  disabled = false,
  label = 'Save',
  loading,
  spinnerClassName,
  variant = 'contained',
  onClick,
  ...restOfProps
}: Props) => {
  const classes = useStyles();
  const handleClick = () => {
    if (!loading && onClick) {
      onClick();
    }
  };

  return (
    <Button
      data-testid="loading-button"
      disabled={disabled || loading}
      variant={variant}
      onClick={handleClick}
      {...restOfProps}
    >
      {!loading && label}
      {loading && (
        <CircularProgress
          data-testid="loading-button-spinner"
          className={classnames(
            variant === 'contained' ? classes.spinnerClass : classes.secondarySpinnerClass,
            spinnerClassName,
          )}
          size={20}
        />
      )}
    </Button>
  );
};

const useStyles = makeStyles((theme: any) => ({
  spinnerClass: {
    color: theme.palette.secondary.contrastText,
  },
  secondarySpinnerClass: {
    color: theme.palette.secondary.main,
  },
}));

export default LoadingButton;
